@if (header.collapsible) {
  <soho-expandable-area [closed]="header.isInitiallyCollapsed" [ngClass]="{'hide-show-more': !useShowMore}">
    <soho-expandable-header>
      <div [class.col-header-container]="header.collapsible" soho-tooltip [content]="title" (click)="onClick($event, true)">
        @if (!useShowMore) {
          <ng-container *ngTemplateOutlet="headerFormatting"></ng-container>
          <svg soho-icon [icon]="buttonIcon" class="icon collapsible-header-icon"></svg>
        }
      </div>
      @if (!useShowMore) {
        <hr class="fieldset-hr collapsible-header-hr">
      }
    </soho-expandable-header>
    <soho-expandable-pane>
      <lm-form-layout
        [formSpec]="formSpec"
        [formOptions]="formOptions"
        [specFields]="specFields"
        [layout]="layoutObject.members"
        [model]="model"
        [formState]="formState"
        [placeHolder]="placeHolder"
        [activatedTabChanged]="activatedTabChanged"
        [formPersonalization]="formPersonalization"
        [parentIsModal]="parentIsModal"
        (fieldEvent)="onFieldEvent($event)"
      ></lm-form-layout>
      @if (!useShowMore) {
        <hr class="fieldset-hr collapsible-header-hr">
      }
    </soho-expandable-pane>
  </soho-expandable-area>
} @else {
  <ng-container *ngTemplateOutlet="headerFormatting"></ng-container>
}

<ng-template #headerFormatting >
  @if (!header.nestedHeader && !titleIsEmpty) {
    <div [class.collapsible-header-div]="collapsibleOnLeftSearch">
      @if ((!header.isFirst || !header.isColumnHeader) && !header.collapsible && !previousSiblingIsCollapsible) {
        <hr class="fieldset-hr">
      }
      @switch (size) {
        @case (1) {
          <h1
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-1' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
            lm-text-style [textStyle]="header?.textStyle" [recalculateStyles]="triggerValueChange | async"
            (click)="onClick($event, true)"
            >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h1>
          }
          @case (2) {
            <h2
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-2' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
              lm-text-style [textStyle]="header?.textStyle"
              (click)="onClick($event, true)" [recalculateStyles]="triggerValueChange | async"
              >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h2>
            }
            @default {
              <h3
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-3' : true,
            'lm-column-header' : header?.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
                lm-text-style [textStyle]="header?.textStyle" [recalculateStyles]="triggerValueChange | async"
                (click)="onClick($event, true)"
                >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h3>
              }
              @case (4) {
                <h4
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-4' : true,
            'lm-column-header' : header.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
                  lm-text-style [textStyle]="header?.textStyle" [recalculateStyles]="triggerValueChange | async"
                  (click)="onClick($event, true)"
                  >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h4>
                }
                @case (5) {
                  <h5
          [ngClass]="{
            'personalize-text' : personalize && !header?.textStyle.color,
            'fieldset-title lm-header-5' : true,
            'lm-column-header' : header.isColumnHeader,
            'on-search': collapsibleOnSearch
          }"
                    lm-text-style [textStyle]="header?.textStyle" [recalculateStyles]="triggerValueChange | async"
                    (click)="onClick($event, true)"
                    >{{title}}<ng-container *ngTemplateOutlet="collapsibleHeaderTemplate"></ng-container></h5>
                  }
                }
              </div>
            }

            <!-- display a line only when using header2 of "_" -->
            @if (!header.nestedHeader && titleIsEmpty) {
              <div>
                <hr class="fieldset-hr">
              </div>
            }

            @if (header.nestedHeader && !titleIsEmpty) {
              @switch (size) {
                @case (1) {
                  <h1
                    [ngClass]="{'lm-header-1' : true, 'lm-column-header' : header?.isColumnHeader}"
                  >{{title}}</h1>
                }
                @case (2) {
                  <h2
                    [ngClass]="{'lm-header-2' : true, 'lm-column-header' : header?.isColumnHeader}"
                  >{{title}}</h2>
                }
                @default {
                  <h3
                    [ngClass]="{'lm-header-3' : true, 'lm-column-header' : header?.isColumnHeader}"
                  >{{title}}</h3>
                }
                @case (4) {
                  <h4
                    [ngClass]="{'lm-header-4' : true, 'lm-column-header' : header.isColumnHeader}"
                  >{{title}}</h4>
                }
                @case (5) {
                  <h5
                    [ngClass]="{'lm-header-5' : true, 'lm-column-header' : header?.isColumnHeader}"
                  >{{title}}</h5>
                }
              }
            }
          </ng-template>

          <ng-template #collapsibleHeaderTemplate>
            @if (header.collapsible) {
              @if (headerError) {
                <svg class="icon-error icon collapsible-header-icon" focusable="false" aria-hidden="true" role="presentation">
                  <use href="#icon-error"></use>
                </svg>
              }
            }
          </ng-template>
